// NATIVE 


// INSTALLED 
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Checkbox, FormControlLabel, Grid, TextField, Typography } from '@mui/material';



// CUSTOM 






/**
 * DetailTurno component displays the details of a specific turno (shift).
 * It uses the `useSelector` hook to retrieve the turno data from the Redux store.
 * The component renders various fields such as cargo name, hora entrada, hora salida, tarifa, and year.
 * It also displays checkboxes for the days the turno applies to (lunes, martes, miercoles, etc.).
 * All fields are read-only.
 *
 * @param {any} props - The properties passed to the component.
 * @returns {JSX.Element} The rendered DetailTurno component.
 */
export const DetailTurno = (props:any) => {


    // USE SELECTOR 
    const { turno }:any  = useSelector( (state:any) => state.turnos );

    

  return (
    <div>
        
        <Grid container>

            <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>

                <TextField
                    fullWidth
                    name={turno.position.name}
                    label={'Cargo'}
                    defaultValue={turno.position.name}
                    InputProps={{
                    readOnly: true,
                    }}
                />
            </Grid>
            <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>

                <TextField
                    fullWidth
                    name={turno.hora_entrada}
                    label={'Hora entrada'}
                    defaultValue={turno.hora_entrada}
                    InputProps={{
                    readOnly: true,
                    }}
                />
            </Grid>
            <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
                <TextField
                    fullWidth
                    name={turno.hora_salida}
                    label={'Hora salida'}
                    defaultValue={turno.hora_salida}
                    InputProps={{
                    readOnly: true,
                    }}
                />
            </Grid>

            <Grid size={{ xs: 7 }} sx={{ padding: 2 }}>
               <TextField
                    fullWidth
                    name={turno.tarifa}
                    label={'Tarifa'}
                    defaultValue={turno.tarifa}
                    InputProps={{
                    readOnly: true,
                    }}
                />
            </Grid>
            <Grid size={{ xs: 5 }} sx={{ padding: 2 }}>
                <TextField
                    fullWidth
                    name={turno.year}
                    label={'Año'}
                    defaultValue={turno.year}
                    InputProps={{
                    readOnly: true,
                    }}
                />
            </Grid>


            <Grid container sx={{ justifyContent: 'center', paddingTop: 2 }}>
                <Typography variant="h6" component="h6">
                Días que aplica el turno
                </Typography>
            </Grid>
            
            

            <Grid container spacing={2} sx={{ padding: 2 }}>
                <Grid size={{ xs: 3 }} >
                   <FormControlLabel
                        control={<Checkbox name={'lunes'} checked={turno.lunes} />}
                        label={'Lunes'}
                    />
                </Grid>
                <Grid size={{ xs: 3 }} >
                    <FormControlLabel
                        control={<Checkbox name={'martes'} checked={turno.martes} />}
                        label={'Martes'}
                    />
                </Grid>
                <Grid size={{ xs: 3 }} >
                    <FormControlLabel
                        control={<Checkbox name={'miercoles'} checked={turno.miercoles} />}
                        label={'Miercoles'}
                    />
                </Grid>
                <Grid size={{ xs: 3 }} >
                   <FormControlLabel
                        control={<Checkbox name={'jueves'} checked={turno.jueves} />}
                        label={'Jueves'}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ padding: 2 }}>
                <Grid size={{ xs: 3 }} >
                    <FormControlLabel
                        control={<Checkbox name={'viernes'} checked={turno.viernes} />}
                        label={'Viernes'}
                    />
                </Grid>
                <Grid size={{ xs: 3 }} >
                    <FormControlLabel
                        control={<Checkbox name={'sabado'} checked={turno.sabado} />}
                        label={'Sabado'}
                    />
                </Grid>
                <Grid size={{ xs: 3 }} >
                    <FormControlLabel
                        control={<Checkbox name={'domingo'} checked={turno.domingo} />}
                        label={'Domingo'}
                    />
                </Grid>
                <Grid size={{ xs: 3 }} >
                    <FormControlLabel
                        control={<Checkbox name={'festivo'} checked={turno.festivo} />}
                        label={'Festivo'}
                    />
                </Grid>
            </Grid>
         
        </Grid>
    </div>
  )
}
